import React, { Component } from "react";

import { Icon } from "@formant/ui/component/common/Icon";

import * as styles from "./ModuleLimitExceeded.scss";

export class ModuleLimitExceeded extends Component {
    public render() {
        return (
            <div className={styles["module-limit-exceeded"]}>
                <Icon name="error" />
                Channel data limit exceeded
                <span>
                    Try adjusting your filter to reduce the amount of data
                </span>
            </div>
        );
    }
}
